import { useEffect, useRef ,useState } from "react";




const TetaviObj = (props) => {
  const THREE = window.Tetavi.THREE;
  const [tetavi, setTetavi] = useState(null);
  const [init, setInit] = useState(false);
  const [pivot, setPivot] = useState(props.pivot);
  let fade = 1
  

  useEffect(() => {
    
    if(tetavi){
      
      tetavi.setAlpha(fade);
    }
      
    
  }, [fade]);
  

useEffect(() => {
    if( tetavi && props.fades){
      tetavi.getSrcVideo().loop = false
      pivot.add(tetavi.getScene());
      props.scene.add(pivot);
      tetavi.tick = (delta) => Tick(delta);
      tetavi.ChangeShader = ChangeShader;
      tetavi.setNormalsShader = setNormalsShader
      tetavi.setNormalsUniforms = setNormalsUniforms
      props.tetaviPlayer.push(tetavi)
      props.setTetaviPlayer(props.tetaviPlayer);
      
    }
    
}, [tetavi,props.fades]);

useEffect(() => {
  if( tetavi && props.pivot){
    
    setPivot(props.pivot)
    
  }
  
}, [props.pivot]);

async function Tick(delta){
  if(!tetavi ) return 

  tetavi.animate();
  var frame = tetavi.getFrame();
  for(let i = 0 ; i < props.fades.length-1; i++){
    
    if( frame > props.fades[i].frame && frame < props.fades[i+1].frame){
      let pivottmp = pivot;
      pivottmp.position.set(props.fades[i].pos[0],props.fades[i].pos[1],props.fades[i].pos[2])
      setPivot(pivottmp)
      Fade(i %2 == 1)
      break;
    }
    
  }
  
}

function ChangeShader(shaderNumber){
  if(!tetavi || shaderNumber < 0 || shaderNumber > 2) return 

    tetavi.changeGeometryType(shaderNumber);
  
  
}

function setNormalsShader(FragWithNormals){
  tetavi.setWithNormalsShader(FragWithNormals);
}

function setNormalsUniforms(params){
  tetavi.setWithNormalsUniforms(params);
}

function Fade(in_out){
  //tetavi.setAlpha(0);
  
  if(in_out){
    if(fade < 1) 
      fade += 1/30
  }else{
    if(fade > 0) 
      fade -= 1/30
  }
  tetavi.setAlpha(fade);
  
}

useEffect(() => {
  if(!init &&props.tetavi_player && props.tetavi_player.dir){
    const dir_path = props.tetavi_player.dir // + ((props.tetavi_player.has_mobile_version && isMobile) ? "_Mobile" : "");
    const texture_video = dir_path+"/texturesVideo.mp4#t=0.001"
    const manifest = dir_path+"/Geometry.manifest"
    let tetaviTmp = props.Tetavi.create(props.renderer,
      props.camera,
      texture_video ,
      manifest).onSetBar(() => {})
      .setFadeAlpha(false)
      .setShadowAngle(0.4)
      .onLog(() => {})
      .onPerform(()=>{})
    if(props.tetavi_player.hasOwnProperty("shadowVisible"))
      tetaviTmp.setShadowVisible(props.tetavi_player.shadowVisible)
    setTetavi(tetaviTmp)
      //tetavi.setAlpha(0.5);
    setInit(true)
      
  }
    

}, [props.tetavi_player]);


useEffect(() => {
  if(props.playState == 'first_play' && tetavi){
    if(tetavi.isReady())
        tetavi.play();
  }
  if((props.playState == 'pause' || props.playState == 'buffering') && tetavi){
    tetavi.pause();
      
  }
  if(props.playState == 'play' && tetavi){
    
    if(tetavi.isPlaying()){
      tetavi.resume();
    }
    else{
      tetavi.play();
    }
  }
    
}, [props.playState]);
  
  return (
    <div >
    </div>
    
  );
}

export default TetaviObj;